"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.TYPE = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _ContentEntity2 = _interopRequireDefault(require("./ContentEntity"));

var _StringHelper = _interopRequireDefault(require("../../helpers/StringHelper"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var TYPE = 'course';
exports.TYPE = TYPE;

var Course = /*#__PURE__*/function (_ContentEntity) {
  (0, _inherits2["default"])(Course, _ContentEntity);

  var _super = _createSuper(Course);

  function Course(json) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, Course);
    _this = _super.call(this, json);
    _this.title = _StringHelper["default"].decodeHtmlEntities(json.title);
    _this.enhancedIcon = json.enhancedIcon;
    _this.icon = json.icon;
    _this.enhancedIconUnactive = json.enhancedIconUnactive;
    _this.iconUnactive = json.icon_unactive;
    _this.enhancedSvgIcon = json.enhancedSvgIcon;
    _this.svgIcon = json.svg_icon;
    _this.spocIds = json.spocs;
    _this.lectureIds = json.lectures;
    _this.newsBlockIds = json.newsBlocks;
    _this.containsLectures = json.containsLectures;
    _this.theme = json.theme;
    _this.enhancedBackground = json.enhancedBackground;
    _this.background = json.background;
    _this.backgroundColor = json.backgroundColor;
    _this.subtitle = json.subtitle;
    _this.unhighlightCondition = json.unhighlightCondition;
    _this.active = json.active;
    _this.order = json.order;
    _this.keyword = json.keyword;
    _this.externalURL = json.externalUrl;
    _this.isPublished = json.published;
    _this.showProgressBar = json.showprogressbar;
    _this.innerColor = json.innercolor;
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(Course.prototype)), "activateTrackings", _thisSuper).call(_thisSuper);
    return _this;
  }

  return Course;
}(_ContentEntity2["default"]);

var _default = Course;
exports["default"] = _default;